<template>
  <div style="max-width: 750px;margin: 0 auto;position: relative">
    <div class="pd-t-50" id="intro">
      <video id="video" src="/server/static/video/1.mp4" class="w-fill"></video>
    </div>
    <img v-if="!playing" class="w-fill position-absolute t-50 w-fill z-index-99" @click="play"
         src="static/images/course/video_h5_bg_normal.png">
    <div class="pd-15">
      <div class="justify-content-space-between">
        <div>
          <div class="text-strong">
            ANKI入门到精通
          </div>
          <div class="align-items-center">
            <div class="c-app-orange fs-18 text-strong">￥69</div>
            <div class="mg-l-10 text-delete c-9 fs-12">原价￥199</div>
            <div class="mg-l-10 c-app-navy fs-12">逐渐恢复原价</div>
          </div>
        </div>
        <div class="align-items-center">
          <a href="https://www.bilibili.com/video/BV15A411u7hP/"
             class="bg-app-green c-f bdr-20 pd-t-5 pd-b-5 pd-l-10 pd-r-10 fs-14">免费试看</a>
        </div>
      </div>
      <div class="c-9 fs-12 mg-t-10 pd-t-10" style="border-top: 1px #eeeeee dashed ;">
        Tips:该课程由ANKI志愿版团队制作，课程收入，<span class="c-app-navy">全部归入志愿版项目开发经费</span>，用于聘请个人开发者和激励志愿者来持续优化ANKI
      </div>
    </div>
    <div class="mg-t-10" style="border-bottom: 8px solid #eeeeee"></div>
    <div class="display-flex">
      <div class="flex-1 c-app-navy h-40 justify-content-center align-items-center">
        <van-icon name="location"/>
        课程介绍
      </div>
      <div class="flex-1 c-9  h-40 justify-content-center align-items-center">
        <a @click.prevent="anchor('mulu')">课程目录</a>
      </div>
      <!--<div class="flex-1 c-9  h-40 justify-content-center align-items-center">-->
      <!--<a @click.prevent="anchor('huodong')">活动</a>-->
      <!--</div>-->
    </div>
    <div class="mg-b-80" style="font-size: 0">
      <img class="w-fill" src="static/images/course/video_intro_a.png">
      <img class="w-fill" src="static/images/course/video_intro_b.png">
      <img id="mulu" class="w-fill" src="static/images/course/video_intro_c.png">
      <img class="w-fill" src="static/images/course/video_intro_d.png">
      <!--<img id="huodong" class="w-fill" src="static/images/course/video_intro_e.png">-->
      <!--<div class="position-relative">-->
      <!--<img class="w-fill" src="static/images/course/video_intro_f.png">-->
      <!--<div class="position-absolute border-3 bdc-f pd-10 box bdr-10" style="width: 76%;top:18%;left: 12%">-->
      <!--<img class="w-fill" src="static/images/course/hb.jpg">-->
      <!--</div>-->
      <!--</div>-->
    </div>
    <div class="position-fixed b-0 w-fill" style="max-width: 750px">
      <div @click="onPaidClick" class="bg-app-blue text-align-center lh-30 fs-12 c-f">
        已购课程信息&gt;
      </div>
      <div class="bg-app-navy pd-10">
        <div v-if="$parent.appInner" class="bg-app-green c-app-navy text-align-center lh-40 bdr-20">
          已下架
        </div>
        <div v-else @click="onBuyClick" class="bg-app-green c-app-navy text-align-center lh-40 bdr-20">
          购买学习课程
        </div>
      </div>
    </div>
    <div class="position-fixed t-0 w-fill z-index-999 " style="max-width: 750px">
      <div class="bg-f justify-content-space-between align-items-center h-50 pd-l-10 pd-r-10">
        <img src="static/images/course/logo.png" class="w-120">
        <div class="lh-36 bdr-20 fs-12 pd-l-20 pd-r-20" style="background-color: #E7EBF6">
          <a class="c-app-navy" href="https://www.ankichinas.cn">Anki探索版</a>
          <span class="mg-l-10 mg-r-10">|</span>
          <a class="c-app-navy" href="https://file.ankichinas.cn">Anki资源网</a>
        </div>
      </div>
      <div v-if="scrollTop > 600" class="bg-f display-flex">
        <div class="flex-1 h-40 justify-content-center align-items-center"
             :class="scrollTop < 2000? 'c-app-navy':'c-9'">
          <van-icon v-if="scrollTop < 2000" name="location"/>
          <a @click.prevent="anchor('intro')">课程介绍</a>
        </div>
        <div class="flex-1 h-40 justify-content-center align-items-center"
             :class="scrollTop > 2000 && scrollTop < 4200? 'c-app-navy':'c-9'">
          <van-icon v-if="scrollTop > 2000 && scrollTop < 4200" name="location"/>
          <a @click.prevent="anchor('mulu')">课程目录</a>
        </div>
        <!--<div class="flex-1 h-40 justify-content-center align-items-center"-->
        <!--:class="scrollTop > 4200 ? 'c-app-navy':'c-9'">-->
        <!--<van-icon v-if="scrollTop > 4200" name="location"/>-->
        <!--<a @click.prevent="anchor('huodong')">活动</a>-->
        <!--</div>-->
      </div>
    </div>
    <van-popup v-model="login" style="width: 90%">
      <h1 class="fs-22 text-align-center">已购课程信息</h1>
      <div class="c-9 fs-12 text-align-center mg-b-10">输入您购买时填写的手机号</div>
      <van-cell-group class="w-fill pd-10 box">
        <van-field label-width="80px" v-model="phone" label="手机号" placeholder="手机号" error-message=""/>
        <van-field label-width="80px" v-model="smsCode" center clearable label="验证码" placeholder="短信验证码">
          <template #button>
            <van-button class="w-80 bg-f3f" @click="sendSMS" size="small">{{smsTxt}}</van-button>
          </template>
        </van-field>
      </van-cell-group>
      <div class="pd-20">
        <van-button @click="onConfirmClick" class="w-fill" type="info">查询</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>

  import request from '../../libs/api.request'

  export default {
    name: "course-info",
    data() {
      return {
        playing: false,
        login: false,
        phone: '',
        smsCode: '',
        smsTxt: '发送验证码',
        scrollTop: 0
      }
    },
    methods: {
      anchor(anchorName) {
        let anchorElement = document.getElementById(anchorName);
        if (anchorElement) {
          anchorElement.scrollIntoView();
        }
      },
      play() {
        var video = document.getElementById("video");
        video.play();
        this.playing = true;
      },
      onPaidClick() {
        let orderId = localStorage.getItem('course-order-id');
        if (orderId) {
          let phone = localStorage.getItem('course-phone');
          if (phone) {
            this.$router.push({path: '/course-order', query: {orderId, phone}});
            return;
          }
        }
        this.login = true;
      },
      onBuyClick() {
        this.$router.push({
          path: '/course-pay'
        })
      },
      sendSMS() {
        if (this.smsTxt != '发送验证码') {
          return;
        }

        request.request({
          url: 'course/sendSMS',
          method: 'post',
          data: {phone: this.phone},
          success: (data) => {
            this.$toast('验证码已发送');
          }
        });

        let time = 60;
        this.smsTxt = time + 's';
        let interval = setInterval(() => {
          time--;
          this.smsTxt = time + 's';
          if (time <= 0) {
            clearInterval(interval);
            this.smsTxt = '发送验证码'
          }
        }, 1000)
      },
      onConfirmClick() {
        if (this.phone.length != 11) {
          this.$toast('请输入正确的手机号');
          return;
        }

        if (this.smsCode.length != 6) {
          this.$toast('请输入正确的验证码');
          return;
        }

        request.request({
          url: 'course/queryOrder',
          method: 'post',
          data: {
            phone: this.phone, smsCode: this.smsCode,
            returnUrl: encodeURIComponent(location.href)
          },
        }).then((data) => {
          localStorage.setItem('course-order-id', data.orderId);
          localStorage.setItem('course-phone', data.phone);
          this.$router.push({path: '/course-order', query: data});
        }).catch((e) => {
          this.$toast(e.message)
        });

      }
    }, mounted() {
      window.onscroll = () => {
        this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        console.log(this.scrollTop);
      }
    }
  }
</script>

<style scoped>
  img {
    margin: 0;
    padding: 0;
  }

  @import "../../assets/course.css";
</style>
